"use client";

import React, {useState} from "react";
import ProjectCard from "./ProjectCard";
import {projects, ProjectProps} from "./projectDetails";
import ProjectModal from "./ProjectModal";

const ProjectGrid = () => {
    const [selected, setSelected] = useState<ProjectProps | null>(null);

    function openProject(p: ProjectProps) {
        setSelected(p);
    }

    function closeProject() {
        setSelected(null);
    }
    return (
        <>
            <div className="mb-10 flex gap-16 text-[#e4ded7] md:mb-16  lg:mb-20 ">
                <h4
                    className={`text-[16px] md:text-[20px] lg:text-[34px] ${"text-[#e4ded7]"}`}
                >
          Check out some of my work!
                </h4>
            </div>

            <div className="grid w-[90%] grid-cols-1 grid-rows-2 gap-y-10 gap-x-6 lg:max-w-[1200px] lg:grid-cols-1">
                {projects.map((project: ProjectProps) => (
                    <ProjectCard
                        id={project.id}
                        key={project.id}
                        name={project.name}
                        description={project.description}
                        technologies={project.technologies}
                        techNames={project.techNames}
                        techLinks={project.techLinks}
                        github={project.github}
                        demo={project.demo}
                        image={project.image}
                        available={project.available}
                        onClick={() => openProject(project)}
                    />
                ))}
            </div>
            {selected && (
                <ProjectModal project={selected} onClose={closeProject} />
            )}
        </>
    );
};

export default ProjectGrid;
